import { ConfirmationPayload } from '../../services/agentApi';

interface ConfirmationCardProps {
    confirmation: ConfirmationPayload;
    onConfirm: () => void;
    onConfirmAll: () => void;
    onCancel: () => void;
    disabled?: boolean;
}

export default function ConfirmationCard({ confirmation, onConfirm, onConfirmAll, onCancel, disabled }: ConfirmationCardProps) {
    return (
        <div className="border border-slate-200 rounded-lg p-3 my-2 bg-slate-50">
            <div className="flex items-center gap-2 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
                <span className="text-sm font-medium text-slate-700">Confirm Action</span>
            </div>

            <p className="text-sm text-slate-600 whitespace-pre-wrap mb-3">
                {confirmation.preview}
            </p>

            <div className="flex justify-end gap-2">
                <button
                    onClick={onCancel}
                    disabled={disabled}
                    className="px-3 py-1.5 text-xs font-medium text-slate-600 bg-white border border-slate-300 rounded-md hover:bg-slate-50 disabled:opacity-50 transition-colors"
                >
                    Cancel
                </button>
                <button
                    onClick={onConfirm}
                    disabled={disabled}
                    className="px-3 py-1.5 text-xs font-medium text-white bg-primary rounded-md hover:bg-primary/90 disabled:opacity-50 transition-colors"
                >
                    Confirm
                </button>
                <button
                    onClick={onConfirmAll}
                    disabled={disabled}
                    className="px-3 py-1.5 text-xs font-medium text-white bg-amber-500 rounded-md hover:bg-amber-600 disabled:opacity-50 transition-colors"
                    title="Auto-confirm this and all further actions without asking"
                >
                    Auto confirm
                </button>
            </div>
        </div>
    );
}
